import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import {Routes, RouterModule} from "@angular/router";

import { AppComponent } from './app.component';
import {HttpClientModule} from '@angular/common/http';
import { FrontJacketComponent } from './front-jacket/front-jacket.component';
import { BackJacketComponent } from './back-jacket/back-jacket.component';
import { DesignOptionsComponent } from './design-options/design-options.component';
import { LeftJacketComponent } from './left-jacket/left-jacket.component';
import { RightJacketComponent } from './right-jacket/right-jacket.component';
import { InnerJacketComponent } from './inner-jacket/inner-jacket.component';
import { SaveDesignComponent } from './save-design/save-design.component';

import { LongPressButton } from './directives/long-press';


// const routes: Routes = [
//  { path: '', component: AppComponent },
//  { path: 'save', pathMatch: 'full', component: SaveDesignComponent }
// ];

@NgModule({
  declarations: [
    AppComponent,
    FrontJacketComponent,
    BackJacketComponent,
    DesignOptionsComponent,
    LeftJacketComponent,
    RightJacketComponent,
    InnerJacketComponent,
    SaveDesignComponent,

    LongPressButton
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    // RouterModule.forRoot(routes, {useHash: true})
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/app.module.ts